/**
 * Etat de session cote client — SANS SECRET (correctif B7).
 *
 * Le jeton JWT etait auparavant range dans localStorage, ce qui annulait le
 * benefice du cookie httpOnly pose par le backend : une seule XSS suffisait a
 * exfiltrer une session soignante valide.
 *
 * L'authentification passe desormais EXCLUSIVEMENT par le cookie httpOnly,
 * invisible au JavaScript. Il reste utile de savoir « suis-je connecte ? »
 * pour eviter des appels reseau inutiles (initPush, ouverture d'un flux SSE...).
 * On ne stocke donc qu'un simple drapeau non sensible : sa fuite via une XSS
 * n'apprend rien a un attaquant et ne lui donne aucun acces.
 *
 * Ce drapeau est un INDICE, pas une autorisation : la seule source de verite
 * reste la reponse du serveur a GET /api/auth/me.
 */

const SESSION_FLAG = 'tabbibak_session';

export const markLoggedIn = () => {
  try { localStorage.setItem(SESSION_FLAG, '1'); } catch (_) {}
};

export const clearLoggedIn = () => {
  try {
    localStorage.removeItem(SESSION_FLAG);
    // Nettoyage des cles heritees de l'ancienne implementation : si un poste
    // conserve un jeton d'avant le correctif, on le supprime au premier passage.
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
  } catch (_) {}
};

export const isLoggedIn = () => {
  try { return localStorage.getItem(SESSION_FLAG) === '1'; } catch (_) { return false; }
};

/**
 * Configuration axios standard : le cookie httpOnly est joint automatiquement.
 * Plus aucun en-tete Authorization n'est construit cote client.
 */
export const authConfig = () => ({
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

/**
 * Variante pour les uploads multipart : on ne force PAS le Content-Type,
 * le navigateur doit poser lui-meme la boundary (sinon 422).
 */
export const uploadConfig = () => ({ withCredentials: true });

/**
 * Lit un cookie non httpOnly. Utilise pour le jeton CSRF uniquement.
 */
/**
 * Jeton CSRF — stocke cote client (cross-domain).
 *
 * Le frontend (tabbibak.com) et l'API (onrender.com) sont sur des domaines
 * differents : un cookie pose par l'API n'est PAS lisible ici. Le backend
 * renvoie donc le jeton CSRF dans le CORPS JSON du login ; on le range en
 * localStorage (ce n'est pas un secret d'authentification, sa fuite ne donne
 * aucun acces) et on le renvoie dans l'en-tete X-CSRF-Token.
 */
const CSRF_KEY = 'tabbibak_csrf';

export const setCsrfToken = (token) => {
  try { if (token) localStorage.setItem(CSRF_KEY, token); } catch (_) {}
};

export const getCsrfToken = () => {
  try { return localStorage.getItem(CSRF_KEY); } catch (_) { return null; }
};

export const clearCsrfToken = () => {
  try { localStorage.removeItem(CSRF_KEY); } catch (_) {}
};

/**
 * Installe l'intercepteur CSRF sur axios : ajoute l'en-tete X-CSRF-Token
 * (jeton signe recu au login) sur toute requete a effet de bord.
 */
export const installCsrfInterceptor = (axios) => {
  axios.interceptors.request.use((config) => {
    const method = (config.method || 'get').toUpperCase();
    if (['GET', 'HEAD', 'OPTIONS'].includes(method)) return config;
    const token = getCsrfToken();
    if (token) {
      config.headers = { ...(config.headers || {}), 'X-CSRF-Token': token };
    }
    return config;
  });
};
